import ServiceContent from "@/model/Content/ServiceContent"

interface IEquipmentServiceContent {

}

class EquipmentServiceContent extends ServiceContent implements IEquipmentServiceContent {

    constructor() {
        super()
    }

}

export default EquipmentServiceContent